import React from "react"
import {Grid } from "@material-ui/core"
import {makeStyles} from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import Yellow from "@material-ui/core/colors/yellow"
import "../../Container/PostAnime.css"
import MusicAnime from "../../UI/Image/music"
import MusicButton from "../../UI/musicButton/ShonenMusic"

const useStyles = makeStyles((theme)=>({
  
    buttonGrid:{
        marginTop:"12px"
    },
 
    grid:{
    
        width:"100%",
        marginTop:"4px",
    
        backgroundColor:Yellow[400],
        borderRadius:"32px",
        marginLeft:"2px",
        marginTop:"20px"
    },

paper:{
    padding:theme.spacing(6),
    color:theme.palette.text.secondary,
    background:theme.palette,
    textAlign:"right",
    

},
img:{
   textAlign:"left",
},

 button:{
     borderRadius:"20px",
      fontFamily:[
     'Luckiest Guy', "cursive"
        ],
        fontWeight:"bold"   
 },
 Typography:{
    width:"70%",
    marginLeft:"18%",
    fontFamily:["Syne Tactile",  "cursive"],
    color:"black",
    fontWeight:"bold",
    textAlign:"center",
    

},

   

}))

const postAnime =()=>{
    const classes = useStyles()
    return(
     
        <Grid container className={classes.grid} >
        
        <Grid item>
       
 
       </Grid>
        
    
        <Grid item xs={12} md={12} className={classes.paper } >  

        <Typography  variant="h5" className={classes.Typography}>    shonen anime is like a action type anime which have long and intresting series but no romentic and love some have revenge love present it is almost see boys which have straight stories
        </Typography>

                <MusicAnime/>
                <MusicButton/>
        </Grid>
        </Grid>
    )
}
export default postAnime


// WEBPACK FOOTER //
// ./src/Dimension/ShonenDimension/shonenmusic.jsx